import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, ViewChild, inject, input, output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { CamAbstractInput } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams } from '@camelot/menu';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, ButtonComponent, ButtonSize, LayoutFullPanelComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationCore } from '../../../translation.service';
import { FilterContainerComponent } from '../filter-container/filter-container.component';

@Component({
  imports: [
    BadgeComponent,
    ButtonComponent,
    CommonModule,
    FilterContainerComponent,
    FontIconComponent,
    LayoutFullPanelComponent,
    NgTemplateOutlet,
    TranslatePipe,
  ],
  selector: 'cam-filter-displayer',
  templateUrl: './filter-displayer.component.html',
})
export class FilterDisplayerComponent extends CamBaseComponent {
  container = input<'button' | 'link'>('button');

  count = input(0);

  form = input<CamAbstractInput[]>([]);

  iconType = input('filter');

  label = input<string>();

  size = input<ButtonSize>('md');

  filtersSelected = output<any>();

  private _bottomSheet = inject(MatBottomSheet);

  @ViewChild('filterTemplate', { read: TemplateRef })
  filterTemplate!: TemplateRef<void>;

  get isFilterOpen() {
    return this._isFilterOpen;
  }
  set isFilterOpen(value: boolean) {
    this._isFilterOpen = value;

    if (this.mobileDetection) {
      if (value) {
        this._bottomSheet.open<BottomSheetTemplateGenericComponent, BottomSheetTemplateGenericParams<null>>(
          BottomSheetTemplateGenericComponent,
          {
            data: {
              context: null,
              template: this.filterTemplate,
            },
            panelClass: 'no-padding',
          }
        );
      } else {
        this._bottomSheet.dismiss();
      }
    }
  }

  get mobileDetection() {
    return this.breakpoints.isMobile;
  }

  private _isFilterOpen = false;

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public close() {
    this.isFilterOpen = false;
  }
  public open() {
    this.isFilterOpen = true;
  }

  public selected(filters: any) {
    this.filtersSelected.emit(filters);
    this.close();
  }
}
